import Header from '@/components/Header';
import About from '@/components/About';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

const AboutPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <SEO
        title="About Freeman & Crown Law | Constitutional Attorneys"
        description="Learn about our constitutional law practice, our mission to protect God-given rights, and our expertise in tax law, constitutional law, and securities law."
        image="/lovable-uploads/623425d9-22e5-4e7d-acc9-9c24a984bf5b.png"
        url={window.location.origin + '/about'}
        type="website"
      />
      <About />
      <Footer />
    </div>
  );
};

export default AboutPage;